<template>
  <div class="finish-question">
    <div class="header">
      <div class="icon-quizz">
        <span>QUIZZ</span>
      </div>
      <div class="tags-quiz">
        <p
          class="tag"
          v-for="(tag, index) in quiz.scriptOptions.tags"
          :key="index"
        >
          {{ tag.name }}
        </p>
      </div>
      <div class="re-quiz" v-on:click="reQuiz">
        <ReloadIcon />
        <span>Làm lại quiz</span>
      </div>
      <p class="name-quiz">{{ quiz.name }}</p>
    </div>

    <div class="result">
      <div class="content">
        <p class="correct">
          Bạn trả lời đúng
          <span class="ratio">{{
            correct_result + " / " + quiz.questions.length
          }}</span>
          câu
        </p>
        <p class="outcome">{{ info.title }}</p>
        <p class="description">{{ info.text }}</p>
      </div>
      <div class="image" v-if="info.media != null">
        <img :src="info.media.value.src" />
      </div>
      <div class="footer">
        <!-- <p class="compare">Số điểm của bạn cao hơn <span>12%</span> số người làm Quizz</p> -->
        <p class="text-share">Chia sẻ ngay với bạn bè!</p>
        <div class="group-btn">
          <div class="share-fb" @click="shareFb(info)">
            <FacebookIcon />
            <span>Chia sẻ</span>
          </div>
          <!-- <div class="coppy-link" @click="coppyLink()">
            <ConnectIcon />
            <span>Sao chép liên kết</span>
          </div>-->
        </div>
      </div>
    </div>

    <div class="submit" v-if="!submitSuccess">
      <div class="submit-title">Ghi danh nhận thưởng</div>
      <div class="submit-desc">
        Người chơi hoàn thành quiz sớm nhất sẽ có cơ hội nhận được những phần
        quà từ Kenh14.vn, mọi thông tin cá nhân của bạn sẽ được bảo mật tuyệt
        đối.
      </div>
      <div class="submit-form">
        <input
          type="text"
          placeholder="Họ và tên"
          :value="player.name"
          @change="(e) => changePlayerInfo(e, 'name')"
        />
        <input
          type="text"
          placeholder="Số điện thoại"
          :value="player.phone"
          @change="(e) => changePlayerInfo(e, 'phone')"
        />
        <input
          type="text"
          placeholder="Email"
          :value="player.email"
          @change="(e) => changePlayerInfo(e, 'email')"
        />
        <input
          type="text"
          placeholder="Link facebook, instagram,..."
          @change="(e) => changePlayerInfo(e, 'url')"
        />
      </div>
      <button class="submit-btn" @click="sendResponse">Ghi danh</button>
    </div>

    <div class="submit-success" v-else>
      <div class="submit-title">Ghi danh thành công</div>
      <div class="submit-desc">
        Chúng tôi sẽ liên hệ nếu bạn trở thành người thắng cuộc
      </div>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30" cy="30" r="30" fill="#24A148" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.0009 22.5987L28.1586 38.6561L18.0703 30.2482L19.9738 27.9641L27.7303 34.4269L38.6811 20.7429L41.0009 22.5987Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import ReloadIcon from "../../ui/icons/svgs/icons/ReloadIcon";
import FacebookIcon from "../../ui/icons/svgs/icons/FacebookIcon";
import ConnectIcon from "../../ui/icons/svgs/icons/ConnectIcon";
import { copyClipboard, addParameter } from "coreutils-js";

export default {
  name: "Result",
  props: ["quiz", "correct_result"],
  components: {
    ReloadIcon,
    FacebookIcon,
    ConnectIcon,
  },
  data() {
    return {
      sharing: false,
      resultId: null,
      player: this.quiz.player,
			submitSuccess: false
    };
  },
  computed: {
    info: function () {
      let infoResult = {};
      const correct = this.correct_result;
      this.quiz.results.filter(function (result) {
        if (result.from <= correct && correct <= result.to) {
          infoResult = result;
        }
      });
      return infoResult;
    },
    // bgImageResult: function(){
    //   if (this.info.media != null){
    //     return this.info.media.value.src.includes('gif') ? this.info.media.value.src + '.png' : this.info.media.value.src
    //   }
    //   return ''
    // }
  },
  methods: {
    reQuiz() {
      this.$store.dispatch("reQuiz");
    },
    shareFb(data) {
      //   if (this.resultId) {
      //     const link = addParameter(
      //       `${this.quiz.scriptOptions.linkShare || document.referrer}`,
      //       {
      //         qid: this.quiz.id,
      //         oid: this.quiz.officer_id,
      //         rid: this.resultId
      //       }
      //     );

      //     this.quiz.action("share", "facebook", data.title, link);

      //     return;
      //   }

      //   if (this.sharing) return;

      //   this.sharing = true;

      //   this.quiz.action(
      //     "sendResult",
      //     {
      //       image: data.media.value.src,
      //       title: data.title,
      //       description: data.text
      //     },
      //     (error, resultId) => {
      //       this.sharing = false;
      //       this.resultId = resultId;

      //       const link = addParameter(
      //         `${this.quiz.scriptOptions.linkShare || document.referrer}`,
      //         {
      //           qid: this.quiz.id,
      //           oid: this.quiz.officer_id,
      //           rid: resultId
      //         }
      //       );

      //       this.quiz.action("share", "facebook", data.title, link);
      //     }
      //   );

      //   this.quiz.action(
      //     "share",
      //     "facebook",
      //     `Đúng ${this.correct_result}/${this.quiz.questions.length} - ${data.title} - ${data.text}`,
      //     `${this.quiz.scriptOptions.linkShare || document.referrer}`
      //   );
      this.quiz.action("share", "facebook", {
        title: data.title,
        image: ((data.media || {}).value || {}).src,
        description: data.text,
        quote: `Đúng ${this.correct_result || 0}/${
          this.quiz.questions.length || 0
        } - ${data.title || ""} - ${data.text || ""}`,
        url: this.quiz.scriptOptions.linkShare,
      });
    },
    // coppyLink() {
    //   copyClipboard(this.quiz.scriptOptions.linkShare);
    // },
    changePlayerInfo(e, name) {
      this.player[name] = e.target.value;
    },
    sendResponse() {
			this.submitSuccess = true;
			const answers = this.$store.getters.getAnswer.map(answer => {
				return {
					question_id: answer.id,
					answer_content: answer.data.join(',')
				}
			})
			this.quiz.action('sendResponses', answers, this.player, (err, data) => {
				console.log(err, data)
			})
		},
  },
};
</script>

<style lang="scss">
.finish-question {
  border-radius: 8px;
  margin: 80px 0 0 0;
  padding: 16px;
  background-size: cover;
  background-position: center center;
  position: relative;
  z-index: 0;
  overflow: hidden;
  background-image: linear-gradient(#ff5e34, #ff9b34);

  .header {
    padding: 0 16px;
    display: flex;
    align-items: center;
    position: relative;
    flex-wrap: wrap;
    margin-bottom: 16px;
    .icon-quizz {
      height: 40px;
      width: 40px;
      background: #ffe700;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: #000000;
        transform: matrix(1, -0.24, 0, 0.97, 0, 0);
        font-size: 10px;
        font-weight: 1000;
      }
    }
    .tags-quiz {
      display: flex;
      .tag {
        background: rgba(0, 0, 0, 0.1);
        margin-left: 8px;
        height: 14px;
        padding: 5px 12px;
        border-radius: 18px;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
        color: #fff;
      }
    }
    .re-quiz {
      cursor: pointer;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -53px;
      top: unset;
      @media screen and (min-width: 500px) {
        right: 16px;
        top: 8px;
        left: unset;
        bottom: unset;
      }
      background: rgba(0, 0, 0, 0.1);
      height: 14px;
      padding: 5px 12px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 12px;
        fill: #fff;
      }
      span {
        font-weight: 600;
        font-size: 12px;
        line-height: 2;
        color: #ffffff;
        margin-left: 6px;
        margin-top: 2px;
      }
    }
    .name-quiz {
      width: 100%;
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      color: #ffffff;
      margin-top: 8px;
      padding-bottom: 32px;
      @media screen and (min-width: 500px) {
        padding-bottom: 0;
      }
    }
  }

  .result {
    margin: 0 16px;
    padding: 24px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .content {
      width: 100%;
      margin-bottom: 20px;
      @media screen and (min-width: 500px) {
        width: calc(100% - 240px);
      }
      .correct {
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #666666;
        margin-bottom: 8px;
        .ratio {
          color: #ff6d19;
        }
      }
      .outcome {
        font-weight: bold;
        font-size: 26px;
        line-height: 30px;
        color: #333333;
        margin-bottom: 16px;
      }
      .description {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #666666;
        white-space: break-spaces;
      }
    }
    .image {
      width: 100%;
      margin-bottom: 20px;
      @media screen and (min-width: 500px) {
        width: 200px;
      }
      img {
        width: 100%;
        border-radius: 8px;
      }
    }
    .footer {
      width: 100%;
      .compare {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #999999;
        span {
          color: #ff6d19;
        }
      }
      .text-share {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #666666;
        margin-bottom: 10px;
      }

      .group-btn {
        width: 230px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .share-fb {
          cursor: pointer;
          background: #3479ea;
          border-radius: 3px;
          width: 82px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 13px;
          line-height: 140%;
          svg {
            width: 12px;
            margin-right: 4px;
          }
        }
        .coppy-link {
          cursor: pointer;
          width: 138px;
          height: 28px;
          background: #f4f4f4;
          border-radius: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999999;
          font-size: 13px;
          line-height: 140%;
          svg {
            width: 12px;
            fill: #999999;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .submit {
    margin: 16px 16px 0 16px;
    padding: 24px;
    background: #ffffff;
    border-radius: 8px;

    .submit-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #666666;
    }

    .submit-desc {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #666666;
      margin-top: 10px;
    }

    .submit-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      input {
        margin-top: 10px;
        border: 1px solid #e5e5e5;
        box-sizing: border-box;
        height: 37px;
        outline: none;
        padding: 0 10px;
        width: calc(50% - 10px);

        &::placeholder {
          font-family: $fontFamily;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          color: #888888;
        }

        &:focus {
          border: 1px solid #fb6630;
        }
      }
    }

    .submit-btn {
      margin-top: 10px;
      background: #fb6630;
      height: 39px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #ffffff;
      width: 100%;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }

  .submit-success {
    margin: 16px 16px 0 16px;
    padding: 24px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .submit-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #666666;
    }

    .submit-desc {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #666666;
      margin-top: 10px;
    }

    svg {
      margin-top: 10px;
    }
  }
}
</style>
